import { PricingTypeDisplay } from '~/constants';
import { display } from '~/utils/displayValues/common';
import technologies from './technologies';
import { Project } from '~/types/project';
import { Portfolio } from '~/types/portfolio';

export default function summary(portfolio: Portfolio) {
  const portfolioProjects = portfolio?.projects?.filter((project: Project) => project?.investorId === portfolio?.investorId) ?? [];
  const portfolioProjectsPricingType = portfolio?.projects?.[0]?.pricingType;
  const pricingTypeDisplay = PricingTypeDisplay[portfolioProjectsPricingType] ?? '';

  return {
    developer: display(portfolio?.installer?.company?.name),
    investor: display(portfolio?.investor?.company?.name),
    projectQuantity: display(portfolioProjects?.length),
    pricingType: display(pricingTypeDisplay),
    description: display(portfolio?.description),
    technologies: technologies(portfolioProjects),
  };
}